export default __webpack_public_path__ + "images/BQ.27b6cba.png";